var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0936 5.90864C16.9713 5.73099 16.8077 5.58573 16.6167 5.48538C16.4258 5.38503 16.2133 5.3326 15.9976 5.3326C15.7819 5.3326 15.5695 5.38503 15.3786 5.48538C15.1876 5.58573 15.024 5.73099 14.9016 5.90864L2.90164 23.242C2.76274 23.4419 2.68129 23.6761 2.66613 23.919C2.65097 24.162 2.70268 24.4045 2.81566 24.6201C2.92863 24.8358 3.09854 25.0163 3.30692 25.1422C3.51531 25.268 3.7542 25.3344 3.99764 25.334L27.9976 25.334C28.2405 25.333 28.4785 25.2658 28.6861 25.1396C28.8936 25.0135 29.0628 24.8331 29.1756 24.618C29.2883 24.4029 29.3402 24.1611 29.3258 23.9186C29.3113 23.6762 29.2311 23.4422 29.0936 23.242L17.0936 5.90864Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.bab2f7e2f0ad9a3c8fdcf320d57f2826.svg";
export { ForwardRef as ReactComponent };